import React, { Component } from 'react'

import './_imageSwiper.css'
import appConfig from '../../config/app'

class ImageSwiper extends Component {
  static defaultProps = {
    images: [],
    selected: 1,
    onValueChanged: () => {}
  }

  constructor(props) {
    super(props)
    this.state = {
      selected: props.selected
    }
  }

  handleNextSlide = (event) => {
    var nextSlide = this.state.selected+1;

    if(nextSlide > this.props.images.length) {
      nextSlide = 1;
    }

    this.setState({selected: nextSlide})
    this.props.onValueChanged(nextSlide);
  }

  handlePrevSlide = (event) => {
    var prevSlide = this.state.selected-1;

    if(prevSlide < 1) {
      prevSlide = this.props.images.length;
    }

    this.setState({selected: prevSlide})
    this.props.onValueChanged(prevSlide);
  }

  render() {
    const { images } = this.props
    const { selected } = this.state

    return (
      <div className="image-swiper">
        <button className="prev-btn" onClick={this.handlePrevSlide}></button>

        <div className="images-wrapper">
          {images.map(item => {
            return( 
            <div 
              className={`image-holder ${(selected === item.id) ? 'active' : ''}`}
              id={`slideNum${item.id}`}
              key={item.id}>
              <img role="presentation" src={appConfig.basePath+item.filename} />
            </div>)
          })}
        </div>

        <button className="next-btn" onClick={this.handleNextSlide}></button>
      </div>
    )
  }
}

export default ImageSwiper


// WEBPACK FOOTER //
// ./src/components/image-swiper/ImageSwiper.js